import { useScrollReveal } from "../../../hooks/useScrollReveal";

const items = [
  {
    label: "Faster testing, lower cost per customer",
    body: "We're in the accounts daily, so tests move in days, not weeks. The faster we cut what's losing and put weight behind what's winning, the lower your cost to land a customer drops. Speed isn't a nicety here, it's the lever that compounds your returns.",
  },
  {
    label: "Profitable growth, not just more spend",
    body: "We start from your real numbers: what a customer is worth and what you can pay to win one. Then we push spend as hard as those numbers allow and no harder. You get growth that still makes money, not a bigger ad bill with nothing to show for it.",
  },
  {
    label: "Data-backed conversion optimization",
    body: "We don't guess what converts, we test it. Every landing page, offer, and booking flow gets measured against real data, and only what proves out stays live. That evidence-based tuning compounds: a higher conversion rate on the same traffic means a lower cost per customer.",
  },
  {
    label: "Real-time reporting, always on",
    body: "You get live login access and a dashboard you can check anytime, not a polished recap once a month. See exactly what's spent, what it's producing, and what we're changing, the moment it happens. You always know where your money stands.",
  },
];

function DiffItem({ item, index }) {
  const [ref, vis] = useScrollReveal(0.1);
  return (
    <div
      ref={ref}
      data-testid={`bend-differentiator-${index + 1}`}
      className={`group grid md:grid-cols-[0.4fr,1fr] gap-6 md:gap-16 lg:gap-24 py-12 md:py-16 border-b border-[#1E293B] reveal ${vis ? 'visible' : ''}`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="flex items-start gap-5">
        <span className="font-['Playfair_Display'] font-semibold text-[48px] md:text-[56px] leading-none text-[#0064E0] opacity-30 select-none">
          {String(index + 1).padStart(2, '0')}
        </span>
      </div>
      <div>
        <h3 className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[28px] lg:text-[32px] text-white leading-[1.15] tracking-[-0.01em]">
          {item.label}
        </h3>
        <p className="mt-4 text-[16px] md:text-[17px] leading-[1.7] text-[#94A3B8]">
          {item.body}
        </p>
      </div>
    </div>
  );
}

export const BendWhyDifferent = () => {
  const [headerRef, headerVis] = useScrollReveal();

  return (
    <section
      id="why-different"
      data-testid="bend-why-different-section"
      className="bg-[#0F172A] py-28 md:py-40 lg:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div ref={headerRef} className={`reveal ${headerVis ? 'visible' : ''}`}>
          <h2
            data-testid="bend-why-different-heading"
            className="font-['Playfair_Display'] font-semibold text-[clamp(36px,5vw,68px)] tracking-[-0.03em] text-white leading-[1.0] max-w-[800px]"
          >
            Why Bend businesses choose us
          </h2>
        </div>

        {/* Items */}
        <div className="mt-16 md:mt-24">
          {items.map((item, i) => (
            <DiffItem key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
